import React from 'react'
import LandingPage from '../components/landingPage'
import { ValueProposition } from '../components/common'
const link = "https://www.youtube.com/embed/DDmkCcMQYBE?rel=0&amp;controls=0&amp;showinfo=0"


const Home = () => {
    return (
        <div>
            <LandingPage/>
            <ValueProposition/>
        </div>
    )
}

export default Home;